export default __webpack_public_path__ + "static/media/Google3.93c0c8da.PNG";